"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function InfoPanel(_ref) {
  var className = _ref.className,
    message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('info-panel', className)
  }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
    className: "info-panel__icon",
    icon: "IconExclamationCircle"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "info-panel__text"
  }, message));
}
InfoPanel.propTypes = {
  /** Class name */
  className: _propTypes["default"].string,
  /** Panel message text */
  message: _propTypes["default"].string.isRequired
};
InfoPanel.defaultProps = {
  className: ''
};
var _default = exports["default"] = InfoPanel;